import _ from 'lodash-extended';
import { findUpperBoundIndexInSorted } from '#/worker/toolkit';

/**
 * @params: [state, getters, rootState, rootGetters]
 */
export default {
  grid(state) {
    const rv = [];
    _.eachIn(state.timeLayer.rows, 'rectangle', (rectangle) => {
      if (rectangle) {
        rv.push(rectangle);
      }
    });
    // console.log(`tmGetters ⟹ grid [${rv.length}]`);
    return rv;
  },

  maxLayerDuration(state) {
    return Math.max(
      state.trackLayer.visualDuration,
      state.trackLayer.audioDuration
    );
  },

  visualData(state) {
    const rv = [];
    _.eachIn(state.trackLayer.visual, 'data', (data) => {
      rv.push(data);
    });
    // console.log(`tmGetters ⟹ visualData [${rv.length}]`);
    return rv;
  },

  isDndMode(state) {
    return (
      state.MODE.VISUAL_DND ||
      state.MODE.ASSET_RESIZE ||
      state.MODE.OVERLAY_DND ||
      state.MODE.OVERLAY_RESIZE ||
      state.MODE.AUDIO_DND ||
      state.MODE.AUDIO_RESIZE ||
      state.MODE.SECONDHAND_DND
    );
  },

  isBusy(state, getters) {
    return (
      getters.isDndMode ||
      state.MODE.SCENE_EDIT ||
      state.MODE.OPTIONAL_AUDIO_INSERT
    );
  },

  shouldShow_TrackLayerTranscript(state, getters, rootState) {
    return (
      getters.shouldShow_TrackLayerAudio ||
      (!_.isEmpty(getters.visualsWithExistingTranscript) &&
        rootState.story.enableVOSubtitles)
    );
  },

  shouldShow_TrackLayerAudio(state, getters, rootState) {
    const selectedAudio = _.filter(
      rootState.story.selectedVoiceOverSegments,
      (a) => !a._deleted
    );
    const hasOnLightbox = !_.isEmpty(selectedAudio);
    const hasOnTimeline = !_.isEmpty(state.trackLayer.audio);

    return hasOnLightbox || hasOnTimeline;
  },

  /**
   * visuals having a record in story transcriptions map
   * @return [{Object}] array of assets
   */
  visualsWithPotentialTranscript(state, getters, rootState) {
    const rv = [];
    _.each(getters.visualData, (asset) => {
      const assetUUID = asset.metadata.assetUUID;
      if (rootState.story.transcriptions[assetUUID]) {
        rv.push(asset);
      }
    });

    if (0 === rv.length && state.dndEscort.trackInHand) {
      const asset = state.dndEscort.trackInHand.data;
      const assetUUID = asset.metadata.assetUUID;
      if (rootState.story.transcriptions[assetUUID]) {
        rv.push(asset);
      }
    }

    return rv;
  },

  /**
   * visuals having non empty transcript tokens
   * @return [{Object}] array of assets
   */
  visualsWithExistingTranscript(state, getters, rootState) {
    const rv = [];
    _.each(getters.visualsWithPotentialTranscript, (asset) => {
      const assetUUID = asset.metadata.assetUUID;
      const hisTranscript = rootState.story.transcriptions[assetUUID];
      if (hisTranscript && !_.isEmpty(hisTranscript.tokens)) {
        rv.push(asset);
      }
    });
    return rv;
  },

  serializedAudioTracks(state) {
    const rv = [];
    _.eachIn(state.trackLayer.audio, 'data', (data) => {
      rv.push({
        assetUUID: data.metadata.assetUUID,
        displayStartTime: data.displayStartTime,
        displayEndTime: data.displayEndTime,
        relativeStartTime: data.relativeStartTime,
        relativeEndTime: data.relativeEndTime,
        assetSubType: data.metadata.assetSubType,
      });
    });
    return rv;
  },

  hasVisualGap(state) {
    if (state.trackLayer.audioDuration) {
      const gap =
        state.trackLayer.audioDuration - state.trackLayer.visualDuration;
      return gap > 0.0001;
    } else {
      return false;
    }
  },

  getBgBeats(state, getters, rootState) {
    let rv = [];

    if (
      rootState.story.bgMusicBeats.length &&
      state.timeLayer.rows.length &&
      state.USE.showBeats
    ) {
      const bgMusicBeats = rootState.story.bgMusicBeats;
      const lastRow = state.timeLayer.rows[state.timeLayer.rows.length - 1];
      const end = findUpperBoundIndexInSorted(
        lastRow.gridEndTime,
        0,
        bgMusicBeats.length - 1,
        bgMusicBeats
      );
      rv = bgMusicBeats.slice(0, end);
    }

    return rv;
  },
};
